module.exports = __webpack_public_path__ + "static/media/16UNODC11.2f356871.jpg";